import React from "react";
import { AcademicPricesForm } from "./AcademixPricesForm";
import { Button } from "../../Button";
import { useAddAcademicPrices } from "../../../hooks/academicPrices/academicPrices.hooks";
import { validateAcademicPricesData } from "../../../Helper/validation/academicFee.validation.helper";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../../Redux/Slices/alert.slice";
import { useDispatch } from "react-redux";
import { parseApiError } from "../../../Helper/apiError.helper";

export const AddAcademicPrices = () => {
  const dispatch = useDispatch();

  const [admissionFee, setAdmissionFee] = React.useState<number | null>(null);
  const [annualFee, setAnnualFee] = React.useState<number | null>(null);
  const [extraClassFee, setExtraClassFee] = React.useState<number | null>(null);
  const [monthlyFee, setMontlyFee] = React.useState<number | null>(null);
  const [examFee, setExamFee] = React.useState<number | null>(null);
  const [stationeryFee, setStationeryFee] = React.useState<number | null>(null);
  const [extraCirculumFee, setExtraCirculumFee] = React.useState<number | null>(
    0
  );
  const [classId, setClassId] = React.useState<number | null>(null);

  const { isLoading: isSavingAcademicPrices, mutate: saveAcademicPrices } =
    useAddAcademicPrices({
      onSuccess: () => {
        dispatch(setSuccessMessage("Academic prices added successfully"));
      },
      onError: (error) => {
        dispatch(setErrorMessage(parseApiError(error)));
      },
    });

  const handleSaveAcademicPrices = () => {
    const warningMessage = validateAcademicPricesData({
      admissionFee,
      annualFee,
      extraClassFee,
      monthlyFee,
      stationeryFee,
      examFee,
      extraCirculumFee,
      classId,
    });

    if (warningMessage) {
      return dispatch(setWarningMessage(warningMessage));
    }

    saveAcademicPrices({
      admission_fee: admissionFee,
      annual_fee: annualFee,
      extra_class_fee: extraClassFee,
      monthly_fee: monthlyFee,
      stationery_fee: stationeryFee,
      exam_fee: examFee,
      extra_carricular_fee: extraCirculumFee,
      class_id: classId as number,
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <AcademicPricesForm
        admissionFee={admissionFee}
        setAdmissionFee={setAdmissionFee}
        annualFee={annualFee}
        setAnnualFee={setAnnualFee}
        extraClassFee={extraClassFee}
        setExtraClassFee={setExtraClassFee}
        monthlyFee={monthlyFee}
        setMontlyFee={setMontlyFee}
        examFee={examFee}
        setExamFee={setExamFee}
        stationeryFee={stationeryFee}
        setStationeryFee={setStationeryFee}
        extraCirculumFee={extraCirculumFee}
        setExtraCirculumFee={setExtraCirculumFee}
        classId={classId}
        setClassId={setClassId}
      />
      <Button
        text="Save"
        loading={isSavingAcademicPrices}
        onClick={handleSaveAcademicPrices}
      />
    </div>
  );
};
